import { render, staticRenderFns } from "./SidebarNavItem.vue?vue&type=template&id=50df400a&"
import script from "./SidebarNavItem.vue?vue&type=script&lang=js&"
export * from "./SidebarNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports